import type { Components } from "@mui/material";

export const MuiIconThemeOptions: Components["MuiIcon"] = {
  defaultProps: {
    baseClassName: "fas",
  },
};
